import React from 'react';

import ArrowFilledDown from './svg/Arrow_Fill_Down.svg';
import AuthenticationRegular from './svg/AuthenticationRegular.svg';
import Close from './svg/Close.svg';
import Company from './svg/Company.svg';
import Contact from './svg/Contact.svg';
import Email from './svg/Email.svg';
import Google from './svg/Google.svg';
import Home from './svg/Home.svg';
import HomeBold from './svg/HomeBold.svg';
import InfoRegular from './svg/InfoRegular.svg';
import Link from './svg/Link.svg';
import Notification from './svg/Notification_regular.svg';
import Profile from './svg/Profile.svg';
import UserID from './svg/User_ID.svg';
import Users from './svg/Users.svg';
import Website from './svg/Website.svg';
import WidgetTemplate from './svg/WidgetTemplate.svg';

const iconTypes = {
  ArrowFilledDown,
  AuthenticationRegular,
  Close,
  Company,
  Contact,
  Email,
  Google,
  Home,
  HomeBold,
  InfoRegular,
  Link,
  Notification,
  Profile,
  UserID,
  Users,
  Website,
  WidgetTemplate,
};

const Icon = ({ type, variant, id }) => {
  const formattedIconType = variant
    ? `${type || 'Home'}${variant}`
    : type || 'Home';
  const IconComponent = iconTypes[formattedIconType];

  return (
    <i id={id} className={'icon-wrapper'}>
      <IconComponent />
    </i>
  );
};

export default React.memo(Icon);
